<template>
    <page-preloader
        v-if="$store.getters.getMyBusinessNewsStatus === 'loading'"
    />
    <announcement-preview
        v-else-if="announcement"
        :announcement="announcement"
        :active-id="announcement.id"
        :clickable="false"
        show-new-badge
    />
    <div v-else>Brak wyników</div>
</template>

<script>
import AnnouncementPreview from '@/components/announcements/AnnouncementPreview.vue'

export default {
    components: {
        AnnouncementPreview
    },

    computed: {
        terms() {
            return this.$store.getters.getMyBusinessNews
        },
        announcement() {
            return this.terms?.sections[0]?.subsections[0]?.news[0]
        }
    },
    watch: {
        terms() {
            this.$store.dispatch('markTermAsRead', this.terms)
        }
    }
}
</script>
